var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sign-component",style:({
    backgroundColor: _vm.background,
    border:_vm.borderWidth + 'px dashed '+ _vm.borderColor,
    borderRadius: _vm.borderRadius + 'px'
  })},[(!_vm.startReceiveData)?_c('div',{staticClass:"placeholder-area"},[_vm._v("签名区")]):_vm._e(),_c('canvas',{ref:"canvas",staticClass:"draw-canvas",attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }